export const styles = {
  container: "flex flex-col items-center text-center p-4 w-[450px] rounded-lg",

  header: {
    container: "flex flex-row justify-between items-center w-full pb-3",
    title: "font-bold text-[22px] text-center text-primary-1050 ml-[27%]",
    closeIcon: "cursor-pointer"
  },

  message: {
    title: "font-semibold text-[14px]",
    subText: "font-normal text-[14px]"
  },

  buttons: {
    container: "flex mt-5 space-x-5",
    yes: "px-6 py-1 border border-transparent bg-green-500 rounded-lg text-white-200",
    no: "px-6 py-1 border border-transparent bg-red-100 rounded-lg text-white-200"
  }
};
